import * as React from "react";
import * as main from "../../styles/main.module.scss";
import * as skills from "./style.module.scss";
export const Skills = () => {
  return (
    <section id="skills" className={skills.skills}>
      <div className={main.containerFluid}>
        <h2 className={`${main.titleH2} ${main.titleWhite}`}>
          Основные навыки для учёбы и жизни, <br/>
          которые приобретает ребёнок после обучения:
        </h2>
        <div className={skills.skills__row}>
          <div className={skills.skills__wrap}>
            <div className={skills.skills__textBlock}>
              <h3 className={skills.skills__title}>Самостоятельность</h3>
              <p className={skills.skills__text}>
                Самостоятельность в планировании, <br/>
                постановке и достижении целей
              </p>
            </div>
          </div>
          <div className={skills.skills__wrap}>
            <div className={skills.skills__textBlock}>
              <h3 className={skills.skills__title}>Концентрация внимания</h3>
              <p className={skills.skills__text}>
                Среднестатистический взрослый человек может <br/>
                сконцентрироваться не дольше 6 минут. <br/>
                После обучения ребенок сможет сосредотачиваться <br/>
                на период от 5 до 10 часов
              </p>
            </div>
          </div>
          <div className={skills.skills__wrap}>
            <div className={skills.skills__textBlock}>
              <h3 className={skills.skills__title}>Усидчивость и мотивация</h3>
              <p className={skills.skills__text}>
                Ребенок научится видеть результаты и прогресс <br/>
                в достижении больших целей, что существенно <br/>
                повысит мотивацию и облегчит учебу
              </p>
            </div>
          </div>
          <div className={skills.skills__wrap}>
            <div className={skills.skills__textBlock}>
              <h3 className={skills.skills__title}>Долгосрочное запоминание</h3>
              <p className={skills.skills__text}>
                Специальные техники запоминания помогут <br/>
                закрепить знания в долгосрочной памяти <br/>
                и воспроизводить их по желанию
              </p>
            </div>
          </div>
          <div className={skills.skills__wrap}>
            <div className={skills.skills__textBlock}>
              <h3 className={skills.skills__title}>Быстрое освоение нового</h3>
              <p className={skills.skills__text}>
                Умение учиться это не только школа и экзамены, для взрослого, это новые профессии <br/>
                и навыки, это терминология для руководства новой рабочей группой и возможность <br/>
                быстро разобраться в технологическом проекте или бизнес-идее. Обучение даст сразу <br/>
                несколько технологий ускоренного обучения под разные задачи и области знания. <br/>
                Усвоив их, ребенок сможет всю жизнь учиться новому со скоростью учебник за 4-5 дней.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
